import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const EmployeeListingSearchSpec = (props) => {
    const {
        title,
        specs
    } = props;

    const shouldRender = specs?.length > 0;
    const [showTable, setShowTable] = React.useState(false);

    const toggleDetails = () => {
        setShowTable(prevState => !prevState);
    };

    return (
        <>
            {shouldRender &&
                <Box pb={1}>
                    <Button variant='contained' size='small' p={2} onClick={toggleDetails}>
                        <Icon baseClassName="fas" className={showTable ? 'fa-caret-down' : 'fa-caret-right'} />
                        {!showTable ? 'Show' : 'Hide'} {title}
                    </Button>
                    {showTable &&
                        <Box pt={1}>
                            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: '700' }}>ID</TableCell>
                                            <TableCell sx={{ fontWeight: '700' }}>Field</TableCell>
                                            <TableCell sx={{ fontWeight: '700' }}>Label</TableCell>
                                            <TableCell sx={{ fontWeight: '700' }}>Value</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {specs?.map((specData) =>
                                            <TableRow key={specData.SpecID}>
                                                <TableCell sx={{ fontWeight: '700' }}>{specData.SpecID}</TableCell>
                                                <TableCell>{specData.SpecField}</TableCell>
                                                <TableCell>{specData.SpecLabel}</TableCell>
                                                <TableCell><div dangerouslySetInnerHTML={{ __html: specData.SpecValue }}></div></TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    }
                </Box>
            }    
        </>
    );
};

export default EmployeeListingSearchSpec;